import { render, staticRenderFns } from "./RevenueNumber.vue?vue&type=template&id=602f5c38&"
import script from "./RevenueNumber.vue?vue&type=script&lang=js&"
export * from "./RevenueNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports